import { render, staticRenderFns } from "./allocationStorehouseApplyList.vue?vue&type=template&id=45f98fe6&scoped=true"
import script from "./allocationStorehouseApplyList.vue?vue&type=script&lang=js"
export * from "./allocationStorehouseApplyList.vue?vue&type=script&lang=js"
import style0 from "./allocationStorehouseApplyList.vue?vue&type=style&index=0&id=45f98fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f98fe6",
  null
  
)

export default component.exports